export default function AboutPage() {
    return <>
    <div className="h2">About Me!</div>
    <div>Hi! I'm Anton. Just a programmer looking for fun things to do!</div>
    <div><a href="http://antonyip.com" target="_blank" rel="noreferrer">www.antonyip.com</a></div>
    <div><a href="https://twitter.com/msgAnton" target="_blank" rel="noreferrer">@msgAnton</a></div>
    <div></div>
    <br />
    <div>You can find the sources of this project at... </div>
    <div><a href="https://github.com/antonyip/terra-dashboard" target="_blank" rel="noreferrer">Link to Github</a></div>
    <br />
    <div>Visit the organizations that motivated me to build this site! </div>
    <div><a href="https://flipsidecrypto.xyz" target="_blank" rel="noreferrer">FlipsideCrypto</a></div>
    <div><a href="https://metricsdao.xyz" target="_blank" rel="noreferrer">MetricsDAO</a></div>
    </>
}
